import { Stack, Title } from "@mantine/core";
import { TestStates } from "@tsTypes/test-schema";
import classes from "./TestStatusTitle.module.css";

export default function TestStatusTitle({
  questionCount,
  attemptedQuestionCount,
  testStatus,
  testMarks,
}: {
  testStatus: TestStates;
  questionCount: number;
  attemptedQuestionCount: number;
  testMarks: { [questionId: string]: number | undefined };
}) {
  const unmarkedQuestionCount = getUnmarkedQuestionCount(
    questionCount,
    testMarks
  );
  return (
    <Stack gap="0">
      <Title order={4} className={classes.title}>
        {testStatus === "paused" || testStatus === "taking"
          ? "Step 1: Take Test"
          : testStatus === "marking"
          ? "Step 2: Mark Test"
          : "Step 3: Review Test"}
      </Title>
      <Title order={6} className={classes.subtitle}>
        {testStatus === "paused"
          ? `Start the timer and attempt the ${
              questionCount - attemptedQuestionCount
            } outstanding questions in this test.`
          : testStatus === "taking"
          ? `Attempt the outstanding ${
              questionCount - attemptedQuestionCount
            } questions. You can pause the timer at any time.`
          : testStatus === "marking"
          ? `Your multiple choice questions have been auto-marked. Mark ${unmarkedQuestionCount} long answer question${
              unmarkedQuestionCount > 1 ? "s" : ""
            } to see your performance.`
          : "Review your test and final performance."}
      </Title>
    </Stack>
  );
}

export function getUnmarkedQuestionCount(
  questionCount: number,
  testMarks: { [questionId: string]: number | undefined }
) {
  const markedQuestionCount =
    Object.values(testMarks).filter((marks) => marks !== undefined).length ?? 0;
  return questionCount - markedQuestionCount;
}
